import { render, staticRenderFns } from "./CommunityFamilyRecord.vue?vue&type=template&id=c046fb7e&scoped=true&"
import script from "./CommunityFamilyRecord.vue?vue&type=script&lang=js&"
export * from "./CommunityFamilyRecord.vue?vue&type=script&lang=js&"
import style0 from "./CommunityFamilyRecord.vue?vue&type=style&index=0&id=c046fb7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c046fb7e",
  null
  
)

export default component.exports